export const SITTINGS = [
  { key: 'breakfast', label: 'Breakfast' },
  { key: 'lunch', label: 'Lunch' },
  { key: 'dinner', label: 'Dinner' }
]

// Convert "HH:MM" to minutes since midnight
export function timeToMinutes(time) {
  if (!time) return null
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}

// Check if two time ranges overlap, handling midnight crossover for dinner
export function rangesOverlap(range1, range2, range1CrossesMidnight = false, range2CrossesMidnight = false) {
  const { start: start1, end: end1 } = range1
  const { start: start2, end: end2 } = range2

  if (start1 === null || end1 === null || start2 === null || end2 === null) {
    return false
  }

  // For ranges that cross midnight, we check two segments
  if (range1CrossesMidnight) {
    // Range1 covers [start1, 1440) and [0, end1]
    const overlapsEvening = start2 < 1440 && end2 > start1 // overlaps with evening portion
    const overlapsMorning = start2 < end1 // overlaps with morning portion (0 to end1)
    return overlapsEvening || overlapsMorning
  }

  if (range2CrossesMidnight) {
    // Range2 covers [start2, 1440) and [0, end2]
    const overlapsEvening = start1 < 1440 && end1 > start2
    const overlapsMorning = start1 < end2
    return overlapsEvening || overlapsMorning
  }

  // Normal overlap check for non-midnight-crossing ranges
  return start1 < end2 && start2 < end1
}

// Validate sitting times and return array of error messages
export function validateSittingTimes(sittingTimes) {
  const errors = []
  const ranges = {}

  // Build ranges object
  for (const { key } of SITTINGS) {
    const times = sittingTimes[key] || {}
    const start = timeToMinutes(times.start)
    const end = timeToMinutes(times.end)
    ranges[key] = { start, end }
  }

  // Check each pair for overlap
  const pairs = [
    ['breakfast', 'lunch'],
    ['lunch', 'dinner'],
    ['breakfast', 'dinner']
  ]

  for (const [key1, key2] of pairs) {
    const range1 = ranges[key1]
    const range2 = ranges[key2]

    // Dinner can cross midnight (end time < start time means it wraps)
    const range1CrossesMidnight = key1 === 'dinner' && range1.start !== null && range1.end !== null && range1.end < range1.start
    const range2CrossesMidnight = key2 === 'dinner' && range2.start !== null && range2.end !== null && range2.end < range2.start

    if (rangesOverlap(range1, range2, range1CrossesMidnight, range2CrossesMidnight)) {
      const label1 = SITTINGS.find(s => s.key === key1).label
      const label2 = SITTINGS.find(s => s.key === key2).label
      errors.push(`${label1} and ${label2} times overlap`)
    }
  }

  return errors
}
